export var toolbarLinks = [{
  text: 'Contact',
  href: '/ah/act/info/contact-us/view'
}, {
  text: 'Help',
  href: 'https://help.allhomes.com.au'
}, {
  text: 'About',
  href: '/about'
}, {
  text: 'Careers',
  href: '/group/career'
}, {
  text: 'Mobile',
  href: '/ah/mobile'
}, {
  text: 'List to Rent',
  href: '/renting'
}, {
  text: 'List to Share',
  href: '/ah/act/advertise/listing-private-share/view'
}, {
  text: 'Advertise with us',
  href: '/advertise'
}];